"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _BlockRound = _interopRequireDefault(require("@rsuite/icon-font/lib/status/BlockRound"));

// Generated by script, don't edit it please.
var BlockRound = (0, _createSvgIcon["default"])({
  as: _BlockRound["default"],
  ariaLabel: 'block round',
  category: 'status',
  displayName: 'BlockRound'
});
var _default = BlockRound;
exports["default"] = _default;
module.exports = exports.default;